$(document).ready(function() {
    var originalTime = parseInt($('.cart-countdown').attr('data-cart-countdown'), 10) * 60; 
    var countdownTime = originalTime; 

    function formatTime(seconds) {
        var minutes = Math.floor(seconds / 60);
        var remainingSeconds = seconds % 60;
        return minutes.toString().padStart(2, '0') + ":" + remainingSeconds.toString().padStart(2, '0');
    }

    function startTimer() {
        var timerInterval = setInterval(function() {
            $('.cart-countdown .time').text(formatTime(countdownTime));
            if (countdownTime > 0) {
                countdownTime--;
            } else {
                clearInterval(timerInterval); 
                $('.cart-countdown .time').text('00:00'); 
                countdownTime = originalTime; 
                setTimeout(startTimer, 1000); 
            }
        }, 1000);
    }
    startTimer();
});



